import { useEffect, useState, useRef } from "react";

/**
 * NProgress-style top bar. Shows during React Suspense loading.
 * Wrap usage: render when a lazy component is loading.
 */
export default function TopProgressBar() {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(true);
  const intervalRef = useRef<ReturnType<typeof setInterval>>();

  useEffect(() => {
    setProgress(30);
    intervalRef.current = setInterval(() => {
      setProgress((p) => {
        if (p >= 90) return p;
        return p + Math.random() * 10;
      });
    }, 300);

    return () => {
      clearInterval(intervalRef.current);
      setProgress(100);
      setTimeout(() => setVisible(false), 200);
    };
  }, []);

  if (!visible && progress >= 100) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] h-[3px]">
      <div
        className="h-full bg-primary transition-all duration-300 ease-out"
        style={{ width: `${Math.min(progress, 100)}%` }}
      />
    </div>
  );
}
